import { set } from '@/utils/vuex.js'

export default {
  SET_FILTER: set('filter'),
  SET_ROLES: set('roles'),
  SET_LOADED_INIT: set('loaded_init')
}
